<template>
  <div class="collect">
    <div class="search-warehouse">
      <div class="add">
        <el-button class="btn-blue" @click="add">新增采集人员</el-button>
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="collectList" style="width: 100%"
      :row-class-name="tableRowClassName">
        <el-table-column 
          v-for="(item, index) in tableTitleList"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="mod(scope.row)">编辑</el-button>
            <el-button class="btn-text" type="text" @click="updateStatus(scope.row)">
              {{ scope.row.status?'关闭':'开启'}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <pagination-tpl
        :total="setCollectPage.total"
        :currentPage="setCollectPage.currentPage"
        :pageSize="setCollectPage.pageSize"
        @queryChange="queryChange"
      ></pagination-tpl>
    </div>
    <!-- 添加采集人员/编辑 -->
    <el-dialog
      :title="collectForm.id ? '编辑' : '新增采集人员'"
      top="26vh"
      :visible.sync="collectDialog"
      width="420px"
    >
      <div class="border"></div>
      <el-form
        ref="collectForm"
        :model="collectForm"
        :rules="collectFormRules"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="collectForm.name" class="white" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="account">
          <el-input v-model="collectForm.account" :disabled="collectForm.id?true:false" class="white" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input v-model="collectForm.password" class="white" type="password" placeholder="请输入密码" autocomplete="new-password"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeCollectDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveCollect('collectForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { modifyNetTitle } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import CollectMixins from "common/mixins/smart-vehicle-inspection/collect";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {
  mixins: [CollectMixins],
  data() {
    return {
      tableTitleList: [
        {label: '姓名', prop: 'name'},
        {label: '账号', prop: 'account'}
      ],
      collectDialog: false,
      collectForm: {
        id: '',
        name: '',
        account: '',
        password: ''
      },
      collectFormRules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ]
      }
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('采集人员')
    this.initCollectList();
  },
  methods: { 
    tableRowClassName({ row }) {
      if (row.status !== 1) {
        return "close-row";
      }
    },
    //翻页
    queryChange(data) {
      this.setCollectPage.currentPage = data.currentPage;
      this.initCollectList();
    },
    //新增
    add() {
      this.collectDialog = true;
    },
    closeCollectDialog() {
      this.collectForm.id = ''
      this.collectForm.name = ''
      this.collectForm.account = ''
      this.collectForm.password = ''
      this.collectDialog = false;
    },
    saveCollect(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.collectForm.id) {
            let data = {};
            data.id = this.collectForm.id;
            data.name = this.collectForm.name;
            data.password = this.collectForm.password;
            SmartVehicleInspection.postModCollect(data).then(res => {
              if (res.success) {
                this.initCollectList();
                this.closeCollectDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.collectForm.name;
            data.account = this.collectForm.account;
            data.password = this.collectForm.password;
            SmartVehicleInspection.postAddCollect(data).then(res => {
              if (res.success) {
                this.initCollectList();
                this.closeCollectDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    mod(row) {
      this.collectForm.id = row.id
      this.collectForm.name = row.name
      this.collectForm.account = row.account
      this.add()
    },
    updateStatus(row) {
      const title = row.status?'是否关闭该人员？':'是否开启该人员？' 
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          this.commonFun(row)
        })
        .catch(() => {});
    },

    commonFun(row) {
      const data = {
        id: row.id,
        status: row.status?0:1,
      } 
      SmartVehicleInspection.postUpdateCollectStatus(data).then(res => {
        if (res.success) {
          this.initCollectList();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.collect {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .search-warehouse {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;
  }
  
  .table .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
    color: #b7b7b7;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
  
  .el-dialog {
    .el-dialog__header {
      padding-left: 20px;
    }
    .el-dialog__body {
      padding: 0px;
      .el-form {
        padding: 20px;
        .el-form-item {
          .el-form-item__label {
            width: 100%;
            text-align: left;
          }
          .el-form-item__content {
            width: 100%;
          }
        }
      }
      .border {
        border-color: #EEEEEE;
        margin-bottom: 0px
      }
    }
    .dialog-footer {
      padding-bottom: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
  
}
</style>
